import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { faPencilAlt, faPray, faXmark } from "@fortawesome/free-solid-svg-icons";
import middleware from "../../Api/Middleware";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Customer.css";
import InputComponent from "./InputComponent";
import ToastSuccess from "../../Toasts/ToastSuccess";
import ToastError from "../../Toasts/ToastError";
import Plus from "./Icons/Add.svg";
import Minus from "./Icons/minus.svg";
import * as RandExp from "randexp";
import ToastInfo from "../../Toasts/ToastInfo";
import { BorderedTextInput } from "../../HouseStyle/Components/Inputs";
import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns";
import { ButtonDarkBlue } from "../../HouseStyle/Components/Buttons";
import { useNavigate } from "react-router";
import Phonenumber from "../Components/Phonenumber";
import { AddressKinds } from "../../Enums/addressKinds";
import { getCountryName } from "../../../utils";

const AddCompanyModal = ({ show, close, createdCompanyCallback, reloadOnSubmit = true }) => {
  const navigate = useNavigate();
  const [debounceTimer, setDebounceTimer] = useState(null);

  const [showCompany, setShowCompany] = useState(false);
  const [countryInfo, setCountryInfo] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [emails, setEmails] = useState([""]);
  const [phoneNumbers, setPhoneNumbers] = useState([
    { country_phone_prefix: "31", phone_number: "" },
  ]);
  const [countryId, setCountryId] = useState();

  const [formData, setFormData] = useState({
    newsPaper: false,
    birthday: false,
  });
  const [errorFields, setErrorFields] = useState({
    company_name: false,
    kvk_number: false,
    btw_number: false,
    first_name: false,
    last_name: false,
    emails: [false, false, false],
    phone_numbers: [false, false, false],
    postal_code: false,
    house_number: false,
    addition: false,
    street_name: false,
    city: false,
    country: false,
  });
  const [address, setAddress] = useState({});
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const vatRegexPatterns = {
    AT: /^ATU\d{8}$/, // Austria
    BE: /^BE0\d{9}$/, // Belgium
    BG: /^BG\d{9,10}$/, // Bulgaria
    CY: /^CY\d{8}[A-Z]$/, // Cyprus
    CZ: /^CZ\d{8,10}$/, // Czech Republic
    DE: /^DE\d{9}$/, // Germany
    DK: /^DK\d{8}$/, // Denmark
    EE: /^EE\d{9}$/, // Estonia
    EL: /^EL\d{9}$/, // Greece
    ES: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/, // Spain
    FI: /^FI\d{8}$/, // Finland
    FR: /^FR[A-Z0-9]{2}\d{9}$/, // France
    GB: /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/, // United Kingdom
    HR: /^HR\d{11}$/, // Croatia
    HU: /^HU\d{8}$/, // Hungary
    IE: /^IE\d[A-Z0-9+*]\d{5}[A-Z]$/, // Ireland
    IT: /^IT\d{11}$/, // Italy
    LT: /^LT(\d{9}|\d{12})$/, // Lithuania
    LU: /^LU\d{8}$/, // Luxembourg
    LV: /^LV\d{11}$/, // Latvia
    MT: /^MT\d{8}$/, // Malta
    NL: /^NL\d{9}B\d{2}$/, // Netherlands
    PL: /^PL\d{10}$/, // Poland
    PT: /^PT\d{9}$/, // Portugal
    RO: /^RO\d{2,10}$/, // Romania
    SE: /^SE\d{12}$/, // Sweden
    SI: /^SI\d{8}$/, // Slovenia
    SK: /^SK\d{10}$/, // Slovakia
  };

  const normalizeLabel = (label) => {
    return label.trim().replace(/[\s\-]+/g, "");
  };

  const getValueInput = useCallback((value, label) => {
    const normalizedLabel = normalizeLabel(label);
    setFormData((prev) => ({ ...prev, [normalizedLabel]: value }));
  }, []);

  const fetchCountry = async () => {
    const [fetchCountries] = await Promise.all([
      middleware.get(`/countryCodes`),
    ]);
    const sorted = fetchCountries.data.data.sort((a, b) => b.order_by - a.order_by);
    const insertIndex = sorted.findIndex((country) => country.order_by === 0);
    setCountryInfo(sorted);
    if (insertIndex !== -1) {
      const before = sorted.slice(0, insertIndex);
      const after = sorted.slice(insertIndex);

      const newOptions = [...before, { disabled: true }, ...after];
      setCountryInfo(newOptions);
    }
  };

  useEffect(() => {
    if (selectedCountry && selectedCountry.country_code_2) {
      setIsCountrySelected(true);
    } else {
      setIsCountrySelected(false);
    }
  }, [selectedCountry]);

  const setPhoneCode = (index, value) => {
    const newPhoneNumbers = [...phoneNumbers];
    newPhoneNumbers[index].country_phone_prefix = value;
    setPhoneNumbers(newPhoneNumbers);
  };

  useEffect(() => {
    if (selectedCountry.country_code_2 == "NL") {
      const { PostalCode, HouseNumber } = formData; // Destructure the relevant fields from formData
      const postalCodeRegex = /^\s*[0-9]{4}\s*[A-Za-z]{2}\s*$/;

      // Clear the previous debounce timer if it exists
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      if (PostalCode) {
        // Set a new debounce timer
        const newDebounceTimer = setTimeout(() => {
          // Check if Postalcode matches the regex
          if (postalCodeRegex.test(PostalCode)) {
            const fetchAdress = async () => {
              if (formData.HouseNumber) {
                try {
                  const response = await fetch(
                    `https://gratispostcodeapi.nl/api/v1/lookup/${PostalCode}/${HouseNumber}`
                  );
                  const data = await response.json();

                  // If the API returns valid postal_code data, populate formData
                  if (data && data.postal_code) {
                    setFormData((prevData) => ({
                      ...prevData,
                      StreetName: data.street,
                      City: data.city,
                      Addition:
                        data.available_suffixes.length > 0
                          ? data.available_suffixes[0]
                          : "",
                    }));
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        street_name: false,
                        city: false,
                      }
                    });
                  } else {
                    ToastError("Geen adres gevonden voor deze postcode.");
                  }
                } catch (error) {
                  ToastError(
                    "Er is een fout opgetreden bij het ophalen de adress gegevens"
                  );
                }
              } else {
                ToastInfo(
                  "Voer het huisnummer in om automatisch de straat en stad in te vullen"
                );
              }
            };

            fetchAdress(); // Call the function to fetch the house number
          }
        }, 1000); // 2 seconds debounce

        setDebounceTimer(newDebounceTimer); // Set the new timer
      }

      return () => clearTimeout(debounceTimer); // Cleanup timer on unmount or when dependencies change
    }
  }, [formData.PostalCode, formData.HouseNumber]);

  useEffect(() => {
    try {
      fetchCountry();
    } catch (error) {
      console.warn(error);
    }
  }, [showCompany]);

  const removeEmailField = async (id) => {
    const confirmDelete = window.confirm(
      "Weet je zeker dat je deze e-mail wilt verwijderen?"
    );
    if (confirmDelete) {
      // Update state after successful deletion

      setEmails(emails.filter((e, index) => index != id));
    }
  };

  const removePhoneNumberField = async (id) => {
    const confirmDelete = window.confirm(
      "Weet je zeker dat je dit telefoonnummer wilt verwijderen?"
    );
    if (confirmDelete) {
      // Update state after successful deletion
      setPhoneNumbers(phoneNumbers.filter((e, index) => index != id));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Voorkom de standaardactie van het formulier
    e.stopPropagation();

    const trimmedData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value])
    );

    const error_messages = validateFormData(trimmedData);
    if (error_messages.length > 0) {
      for (let i = 0; i < error_messages.length; i++) {
        ToastError(error_messages[i]);
      }
      return;
    }

    let userEmails;
    let userPhone;
    userEmails = emails;
    userPhone = phoneNumbers.map((number) => ({
      ...number,
      fullnumber: "+" + number.country_phone_prefix + "-" + number.phone_number,
    }));
    if (userEmails.length == 1 && userEmails[0] === "") {
      userEmails = [];
    }
    if (userPhone.length == 1 && userPhone[0].phone_number == undefined) {
      userPhone = [];
    }

    storeBusiness(userEmails, userPhone);
  };

  const validateFormData = (trimmedData) => {
    setFormData(trimmedData);
    let selectedCountryCode = "NL";
    if (selectedCountry.country_code_2 != undefined) {
      selectedCountryCode = selectedCountry.country_code_2;
    }
    const vatRegex = vatRegexPatterns[selectedCountryCode];
    const postalCodeRegex = /^\s*[0-9]{4}\s*[A-Za-z]{2}\s*$/;
    const phoneRegex = /^\d+$/;
    const cocRegex = /^\d{1,12}(\/\d{1,12})*$/;
    let errors = [];
    let unfilled_fields = [];

    // Checken voor algemene errors
    if (
      trimmedData.CocNumber &&
      (!cocRegex.test(trimmedData.CocNumber))
    ) {
      errors.push("Mag niet meer dan 12 characters en niet minder dan 8 characters bij KVK nummer hebben");
      setErrorFields((prev) => {
        return {
          ...prev,
          kvk_number: true
        }
      });
    }

    setEmails(prev => prev.map(email => email.trim()));
    let formEmails = emails;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    formEmails = formEmails.filter(email => email.trim() !== "");
    setEmails(formEmails);
    formEmails.forEach((email, index) => {
      if (!emailPattern.test(email)) {
        errors.push("Email formaat is ongeldig");
        setErrorFields((prev) => {
          const oldEmails = [...prev.emails];
          oldEmails[index] = true;
          return { ...prev, emails: oldEmails };
        });
      }
    });

    if (phoneNumbers.length > 0) {
      for (let index = 0; index < phoneNumbers.length; index++) {
        if (phoneNumbers[index].phone_number == "") { // Haal lege velden weg
          phoneNumbers.splice(index, 1);
          index--;
          continue;
        }
        if (phoneNumbers[index].phone_number.startsWith('0')) {
          setPhoneNumbers((prev) => {
            const newData = [...prev];
            const updatedValue = newData[index].phone_number.toString().slice(1);
            newData[index] = {
              ...newData[index],
              phone_number: updatedValue
            }
            return newData;
          })
        }
        if (phoneNumbers != 0) {
          if (!phoneRegex.test(phoneNumbers[index].phone_number)) {
            errors.push("Telefoonnummer formaat is ongeldig");
            setErrorFields((prev) => {
              let updatedPhone = [...prev.phone_numbers];
              updatedPhone[index] = true;
              return {
                ...prev,
                phone_numbers: updatedPhone
              }
            });
          }
        }
      }
    }

    if (trimmedData.PostalCode && postalCodeRegex && !postalCodeRegex.test(trimmedData.PostalCode)) {
      errors.push("Postcode formaat is ongeldig");
      setErrorFields((prev) => {
        return {
          ...prev,
          postal_code: true
        }
      })
    }

    if (trimmedData.VatNumber && vatRegex && !vatRegex.test(trimmedData.VatNumber)) {
      errors.push(`Ongeldig BTW-nummer formaat voor ${selectedCountry.country}.`);
      setErrorFields((prev) => {
        return {
          ...prev,
          btw_number: true
        }
      });
    }

    // Lege velden checken
    const errorPush = (field, userText) => {
      unfilled_fields.push(userText);
      setErrorFields((prev) => {
        return {
          ...prev,
          [field]: true
        }
      });
    }

    if (selectedCountry?.country_code_id == undefined) errorPush("country", "land");
    if (!trimmedData.CompanyName) errorPush("company_name", "bedrijfsnaam");
    // if (!trimmedData.CocNumber) errorPush("kvk_number", "KVK nummer");
    // if (!trimmedData.VatNumber) errorPush("btw_number", "BTW nummer");
    if (!trimmedData.FirstName) errorPush("first_name", "voornaam");
    if (!trimmedData.LastName) errorPush("last_name", "achternaam");
    if (!trimmedData.PostalCode) errorPush("postal_code", "postcode");
    if (!trimmedData.HouseNumber) errorPush("house_number", "huisnummer");
    if (!trimmedData.StreetName) errorPush("street_name", "straat");
    if (!trimmedData.City) errorPush("city", "stad");
    if (unfilled_fields.length > 0) {
      errors.push("De volgende velden zijn veplicht: " + unfilled_fields.join(", "));
    }
    return errors;
  }

  const storeBusiness = async (userEmails, userPhone) => {
    try {
      const response = await middleware.post("/addBusinesses", {
        company_name: formData.CompanyName,
        cocnumber: formData.CocNumber,
        vatnumber: formData.VatNumber,
        first_name: formData.FirstName,
        last_name: formData.LastName,
        country_code_id: selectedCountry.country_code_id || null,
        emails: userEmails,
        phone_numbers: userPhone,
        city: formData.City,
        streetname: formData.StreetName,
        birthday: formData.BirthDate,
        housenumber: formData.HouseNumber,
        addition: formData.Addition === "" ? null : formData.Addition,
        postalcode: formData.PostalCode,
        newsletter: formData.newsPaper == false ? 0 : 1,
        birthday_promotion: formData.birthday_promotion == false ? 0 : 1,
        address_kind: AddressKinds.DELIVERY_AND_INVOICE_ADDRESS,
      });

      ToastSuccess("Bedrijf is aangemaakt");
      if (reloadOnSubmit) {
        navigate(`/klanten/bewerken/${response.data.data.internal_id}`);
      } else {
        const newCompany = {
          ...response.data.data,
          contact_persons: `${formData.FirstName} ${formData.LastName}`
        };
        
        if (createdCompanyCallback) createdCompanyCallback(newCompany);
        closeCompanyModal();
      }
    } catch (err) {
      ToastError("Er is iets fout gegaan bij het aanmaken van een bedrijf.");
      console.error(err);
    }
  }

  useEffect(() => {
    if (show) {
      setShowCompany(true);
    }
  }, [show]);

  const clearFormFields = () => {
    setFormData({});
    setErrorFields({
      company_name: false,
      kvk_number: false,
      btw_number: false,
      first_name: false,
      last_name: false,
      emails: [false, false, false],
      phone_numbers: [false, false, false],
      postal_code: false,
      house_number: false,
      addition: false,
      street_name: false,
      city: false,
      country: false,
    });
    setPhoneNumbers([{ country_phone_prefix: 31, phone_number: "" }]);
    setEmails([""]);
  };

  const closeCompanyModal = () => {
    setShowCompany(false);
    close(true);
    clearFormFields();
  };

  const addEmailField = () => {
    if (emails.length < 3) {
      setEmails([...emails, ""]);
    }
  };

  const handleEmailChange = (index, value) => {
    const newEmails = [...emails];
    newEmails[index] = value;

    setEmails(newEmails);
  };

  const addPhoneNumberField = () => {
    if (phoneNumbers.length < 3) {
      const lastPhoneNumber = phoneNumbers[phoneNumbers.length - 1];
      const defaultPrefix = lastPhoneNumber?.country_phone_prefix || "31";
      setPhoneNumbers([...phoneNumbers, { country_phone_prefix: defaultPrefix, phone_number: "" }]);
    }
  };

  const handlePhoneNumberChange = (index, value) => {
    const newPhoneNumbers = [...phoneNumbers];
    newPhoneNumbers[index].phone_number = value;
    setPhoneNumbers(newPhoneNumbers);
  };

  return (
    <Modal
      id="modalBlueprint"
      show={showCompany}
      onHide={() => closeCompanyModal()}
      size="xl"
      centered
    >
      <Modal.Header className="modalTop d-flex justify-content-between align-items-center">
        <div className="d-flex flex-row gap-4 flex-wrap align-items-center">
          <h4 className="fw-semibold text-nowrap">Bedrijf aanmaken</h4>
          <BorderedDropDown
            placeholder="Kies een land"
            error={errorFields.country}
            searchable={true}
            selectedValue={selectedCountry.country_code_id || ''}
            setSelectedValue={(value) => {
              setSelectedCountry(countryInfo.find(country => country.country_code_id === value));
              setErrorFields((prev) => {
                return {
                  ...prev,
                  country: false
                }
              })
            }
            }
            options={
              countryInfo && countryInfo?.length > 0
                ? countryInfo.map((country, index) => {
                  return {
                    key: index,
                    value: country.country_code_id,
                    title: getCountryName(country.country_code_2),
                    disabled: country.disabled
                  };
                })
                : []
            }
          />
        </div>
        <button
          variant="transparent"
          className="btn"
          onClick={() => closeCompanyModal()}
        >
          <FontAwesomeIcon icon={faXmark} className="closeModal text-dark" />
        </button>
      </Modal.Header>
      <Modal.Body className="modalCenter">
        <div className="contendModal w-100">
          <form>
            <div>
              <label className=" fw-bold mb-2 secondaryTitles pt-3">
                Bedrijfsgegevens
              </label>
              <div className="col-12 d-flex flex-row align-content-end mb-3">
                <BorderedTextInput
                  label={"Bedrijfsnaam"}
                  size="l"
                  error={errorFields.company_name}
                  inputValue={formData.CompanyName}
                  setInputValue={(value) => {
                    getValueInput(value, "CompanyName");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        company_name: false
                      }
                    })
                  }
                  }
                />
              </div>
              <div className="col-12 d-flex flex-row gap-4 align-content-end mb-4">
                <BorderedTextInput
                  label={"KVK nummer"}
                  placeholder="Bijv. 123456789012"
                  error={errorFields.kvk_number}
                  size="l"
                  inputValue={formData.CocNumber}
                  setInputValue={(value) => {
                    getValueInput(value, "CocNumber");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        kvk_number: false
                      }
                    })
                  }
                  }
                />
                <BorderedTextInput
                  label={"BTW nummer"}
                  error={errorFields.btw_number}
                  placeholder={"Bijv. NL123456789B01"}
                  size="l"
                  inputValue={formData.VatNumber}
                  setInputValue={(value) => {
                    const cleaned = value === "" ? null : value;
                    getValueInput(cleaned, "VatNumber");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        btw_number: false
                      }
                    })
                  }
                  }
                />
              </div>
            </div>
            <div>
              <label className=" fw-bold mb-2 secondaryTitles">
                Contactpersoon
              </label>
              <div className="col-12 d-flex flex-row gap-4 align-content-end mb-3">
                <BorderedTextInput
                  label={"Voornaam"}
                  error={errorFields.first_name}
                  size="l"
                  inputValue={formData.FirstName}
                  setInputValue={(value) => {
                    getValueInput(value, "FirstName");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        first_name: false
                      }
                    })
                  }
                  }
                />
                <BorderedTextInput
                  label={"Achternaam"}
                  size="l"
                  error={errorFields.last_name}
                  inputValue={formData.LastName}
                  setInputValue={(value) => {
                    getValueInput(value, "LastName");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        last_name: false
                      }
                    })
                  }
                  }
                />
              </div>
              <div className="col-12 d-flex flex-row align-content-end my-3">
                <div className="d-flex flex-column gap-2 col-6 pe-3">
                  <div className="d-flex justify-content-between">
                    <label className="mb-2">Emails</label>
                    <img
                      className="pe-3 addIconSizeModals"
                      src={Plus}
                      onClick={addEmailField}
                      alt="Add"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {emails.map((email, index) => (
                    <div key={index} className="d-flex">
                      <BorderedTextInput
                        size={"l"}
                        error={errorFields.emails[index]}
                        inputValue={email}
                        setInputValue={(value) => {
                          if (value.includes(' ')) return;
                          setEmails((prevEmails) => {
                            const updatedEmails = [...prevEmails];
                            updatedEmails[index] = value;
                            return updatedEmails;
                          });
                          setErrorFields((prev) => {
                            const updatedError = [...prev.emails];
                            updatedError[index] = false;
                            return {
                              ...prev,
                              emails: updatedError
                            }
                          })
                        }
                        }
                      />
                      <img
                        className="ms-2 removeIconSizeModals"
                        src={Minus}
                        onClick={() => removeEmailField(index)}
                        alt="Remove"
                        style={{ cursor: "pointer", width: "3%" }}
                      />
                    </div>
                  ))}
                </div>
                <div className="d-flex flex-column gap-2 col-6 ps-3">
                  <div className="d-flex justify-content-between">
                    <label className="mb-2">Telefoonnummers</label>
                    <img
                      className="pe-3 addIconSizeModals"
                      src={Plus}
                      onClick={addPhoneNumberField}
                      alt="Add"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {phoneNumbers.map((phoneNumber, index) => (
                    <Phonenumber
                      key={index}
                      index={index}
                      phonenumber={phoneNumber}
                      setPhoneCode={(value) => setPhoneCode(index, value)}
                      handlePhoneNumberChange={(newNum) => {
                        setPhoneNumbers((prevNums) => {
                          const updatedNums = [...prevNums];
                          updatedNums[index].phone_number = newNum;
                          return updatedNums;
                        });
                        setErrorFields((prev) => {
                          let updatedError = [...prev.phone_numbers];
                          updatedError[index] = false;
                          return {
                            ...prev,
                            phone_numbers: updatedError
                          }
                        });
                      }}
                      removePhoneNumberField={() => removePhoneNumberField(index)}
                      removable={true}
                    />
                  ))}
                </div>
              </div>
              <div className="col-12 d-flex flex-row align-content-end my-3">
                <InputComponent
                  type={"date"}
                  onValueChange={getValueInput}
                  parentCol={6}
                  labelName={"Geboortedatum"}
                  labelValue={"BirthDate"}
                  classnamesInput={"col-12 widthInputComponents px-3"}
                />

                {/* Removed the news and birthday promotion until it works */}
                {/* <div className="col-6 d-flex justify-content-start">
                  <div className="col-4 d-flex flex-column">
                    <label className="mb-2 ms-4 fw-medium">Nieuwsbrief</label>
                    <label className="switchNewCustomer ms-4">
                      <input type="checkbox" />
                      <span className="sliderNewCustomer round"></span>
                    </label>
                  </div>
                  <div className=" col-4  d-flex flex-column">
                    <label className="mb-2 ms-4 fw-medium">
                      Verjaardagactie
                    </label>
                    <label className="switchNewCustomer ms-4">
                      <input type="checkbox" />
                      <span className="sliderNewCustomer round"></span>
                    </label>
                  </div>
                </div> */}
              </div>

              <div className="col-12 d-flex flex-row gap-3 align-content-end my-3">
                <BorderedTextInput
                  label={"Postcode"}
                  size="l"
                  error={errorFields.postal_code}
                  inputValue={formData.PostalCode}
                  setInputValue={(value) => {
                    getValueInput(value, "PostalCode");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        postal_code: false
                      }
                    })
                  }
                  }
                  disabled={!isCountrySelected}
                />
                <div className="col-6 d-flex justify-content-end">
                  <div className="col-12 d-flex widthInputComponents flex-row gap-1 justify-content-end">
                    <BorderedTextInput
                      label={"Huisnummer"}
                      size="l"
                      error={errorFields.house_number}
                      inputValue={formData.HouseNumber}
                      setInputValue={(value) => {
                        getValueInput(value, "HouseNumber");
                        setErrorFields((prev) => {
                          return {
                            ...prev,
                            house_number: false
                          }
                        })
                      }
                      }
                      disabled={!isCountrySelected}
                    />
                    <BorderedTextInput
                      label={"Toevoeging"}
                      size="l"
                      error={errorFields.addition}
                      inputValue={formData.Addition}
                      setInputValue={(value) => {
                        getValueInput(value, "Addition");
                        setErrorFields((prev) => {
                          return {
                            ...prev,
                            addition: false
                          }
                        })
                      }
                      }
                      disabled={!isCountrySelected}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 d-flex flex-row gap-4 align-content-end my-3 ">
                <BorderedTextInput
                  type={"text"}
                  error={errorFields.street_name}
                  onValueChange={getValueInput}
                  size={"l"}
                  label={
                    <>
                      Straat
                      {selectedCountry.country_code_2 === "NL" &&
                        formData.StreetName && (
                          <FontAwesomeIcon
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                StreetNameEditable: !prev.StreetNameEditable,
                              }))
                            }
                            icon={faPencilAlt}
                          />
                        )}
                    </>
                  }
                  inputValue={formData.StreetName}
                  setInputValue={(value) => {
                    getValueInput(value, "StreetName");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        street_name: false
                      }
                    })
                  }
                  }
                  disabled={
                    !selectedCountry.country_code_2 ||
                    (!formData.StreetNameEditable &&
                      selectedCountry.country_code_2 === "NL")
                  }
                  defaultValue={formData.Street}
                />
                <BorderedTextInput
                  size={"l"}
                  error={errorFields.city}
                  labelName={
                    <>
                      Stad
                      {selectedCountry.country_code_2 === "NL" &&
                        formData.City && (
                          <FontAwesomeIcon
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                CityEditable: !prev.CityEditable,
                              }))
                            }
                            icon={faPencilAlt}
                          />
                        )}
                    </>
                  }
                  label={"City"}
                  inputValue={formData.City}
                  setInputValue={(value) => {
                    getValueInput(value, "City");
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        city: false
                      }
                    })
                  }
                  }
                  disabled={
                    !selectedCountry.country_code_2 ||
                    (!formData.CityEditable &&
                      selectedCountry.country_code_2 === "NL")
                  }
                  defaultValue={formData.City}
                />
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer className="modalBottom">
          <ButtonDarkBlue
            onClickFunction={handleSubmit}
            text={"Bedrijf aanmaken"}
          />
      </Modal.Footer>
    </Modal>
  );
};

export default AddCompanyModal;
